import { render, staticRenderFns } from "./AdminEmbroideredStripsScreen.vue?vue&type=template&id=9339f25a&scoped=true&"
import script from "./AdminEmbroideredStripsScreen.vue?vue&type=script&lang=js&"
export * from "./AdminEmbroideredStripsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9339f25a",
  null
  
)

export default component.exports